<template>
	<section class="consultation-section">
		<div class="container">
			<div class="section-header center">
				<h2 class="section-title">{{ $t('consultationSection.sectionTitle') }}</h2>
				<div class="section-divider"></div>
				<p class="section-description">{{$t('consultationSection.sectionDescription')}}</p>
			</div>

			<div class="cards-container">
				<!-- 数据库服务卡片 -->
				<div class="service-card">
					<div class="card-visual">
						<img v-lazy-img="require('@/assets/images/sjk1.png')" alt="数据库服务" class="card-icon" />
						<div class="visual-effects">
							<div class="effect-circle blue"></div>
							<div class="effect-circle green"></div>
						</div>
					</div>
					<div class="card-content">
						<span class="card-category">{{$t('consultationSection.services.dataService.category')}}</span>
						<h3 class="card-title">{{$t('consultationSection.services.dataService.title')}}</h3>
						<ul class="feature-list">
							<li v-for="(feature, index) in $t('consultationSection.services.dataService.features')"
								:key="'certification-' + index">
								<svg class="feature-icon" viewBox="0 0 24 24">
									<path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
								</svg>
								{{ feature }}
							</li>
						</ul>
					</div>
				</div>

				<!-- 认证服务卡片 -->
				<div class="service-card">
					<div class="card-visual">
						<img v-lazy-img="require('@/assets/images/CNAS.png')" alt="认证服务" class="card-icon" />
						<div class="visual-effects">
							<div class="effect-circle blue"></div>
							<div class="effect-circle green"></div>
						</div>
					</div>
					<div class="card-content">
						<span class="card-category">{{$t('consultationSection.services.certificationService.category')}}</span>
						<h3 class="card-title">{{$t('consultationSection.services.certificationService.title')}}</h3>
						<ul class="feature-list">
							<li v-for="(feature, index) in $t('consultationSection.services.certificationService.features')"
								:key="'certification-' + index">
								<svg class="feature-icon" viewBox="0 0 24 24">
									<path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
								</svg>
								{{ feature }}
							</li>
						</ul>
					</div>
				</div>

				<!-- 移动应用卡片 -->
				<div class="service-card">
					<div class="card-visual">
						<img v-lazy-img="require('@/assets/images/jdb.png')" alt="移动应用" class="card-icon" />
						<div class="visual-effects">
							<div class="effect-circle blue"></div>
							<div class="effect-circle green"></div>
						</div>
					</div>

					<div class="card-content">
						<span class="card-category">{{$t('consultationSection.services.mobileApp.category')}}</span>
						<h3 class="card-title">{{$t('consultationSection.services.mobileApp.title')}}</h3>
						<ul class="feature-list">
							<li v-for="(feature, index) in $t('consultationSection.services.mobileApp.features')"
								:key="'certification-' + index">
								<svg class="feature-icon" viewBox="0 0 24 24">
									<path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
								</svg>
								{{ feature }}
							</li>
						</ul>
					</div>
				</div>
			</div>

			<div class="partners-section">
				<h3 class="partners-title">{{$t('consultationSection.partnersSectionTitle')}}</h3>
				<div class="partners-grid">
					<div class="partner-item" v-for="(partner, index) in $t('consultationSection.partners')" :key="index">
						<div class="partner-logo">
							<img v-lazy-img="getPartnerImage(index)" :alt="partner.alt" />
						</div>
						<span class="partner-name">{{ partner.name }}</span>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	export default {
		name: 'ConsultationServices',
		methods: {
			getPartnerImage(index) {
				const imageMap = [
					require('@/assets/images/hg.jpg'),
					require('@/assets/images/dgm.png'),
					require('@/assets/images/xn.jpg'),
					require('@/assets/images/shhg.png'),
					require('@/assets/images/mhes.png'),
					require('@/assets/images/tjjj.jpg')
				];
				return imageMap[index] || '';
			}
		}
	};
</script>

<style lang="scss" scoped>
// === Design System Variables (aligned with Home.vue) ===
$primary: #0052CC;
$primary-dark: #0043A8;
$primary-light: #3B7FFF;
$heading: #0A1628;
$silver: #8E9EAB;
$light: #F4F7FB;
$body: #5B6C7F;
$success: #10b981;

.consultation-section {
	font-family: 'Rubik', 'Poppins', system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
	color: $body;
	line-height: 1.6;
	position: relative;
	overflow: hidden;
}

.container {
	max-width: 100%;
	margin: 0 auto;
	padding: 0;
}

.section-header {
	text-align: center;
	margin-bottom: 40px;

	.section-tag {
		display: inline-block;
		font-size: 0.85rem;
		font-weight: 700;
		letter-spacing: 3px;
		color: $primary;
		background: rgba(0, 82, 204, 0.06);
		border: 1px solid rgba(0, 82, 204, 0.12);
		padding: 5px 18px;
		border-radius: 100px;
		margin-bottom: 14px;
		text-transform: uppercase;
	}

	.section-title {
		font-size: 2.6rem;
		font-weight: 700;
		color: $heading;
		margin: 0 0 12px 0;
		letter-spacing: -0.5px;
		line-height: 1.2;

		&::after {
			content: '';
			display: block;
			width: 80px;
			height: 4px;
			background: linear-gradient(to right, $primary, $primary-light);
			border-radius: 2px;
			margin: 12px auto 0;
		}

		@media (max-width: 768px) {
			font-size: 1.8rem;
		}

		@media (max-width: 480px) {
			font-size: 1.5rem;
		}
	}

	.section-divider {
		display: none;
	}

	.section-description {
		font-size: 1rem;
		color: $body;
		max-width: 640px;
		margin: 0 auto;
		line-height: 1.7;
		font-weight: 400;
	}
}

.cards-container {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
	gap: 24px;
	margin-bottom: 3rem;
}

.service-card {
	background: #fff;
	border-radius: 16px;
	box-shadow: 0 4px 18px rgba(0, 0, 0, 0.05);
	overflow: hidden;
	display: flex;
	flex-direction: column;
	transition: all 0.35s cubic-bezier(0.22, 1, 0.36, 1);
	position: relative;
	border: 1px solid rgba(0, 82, 204, 0.08);

	&:hover {
		transform: translateY(-6px);
		box-shadow: 0 16px 40px rgba(0, 82, 204, 0.15);
		border-color: rgba(0, 82, 204, 0.25);
	}
}

.card-visual {
	height: 12rem;
	position: relative;
	overflow: hidden;
	background: linear-gradient(135deg, #f5fbfe 0%, rgba(0, 82, 204, 0.06) 100%);
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 1.5rem;
}

	.app-card .card-visual {
	background: linear-gradient(135deg, rgba(0, 82, 204, 0.08) 0%, #e8f5e9 100%);
	}

.card-icon {
	width: 12rem;
	height: 12rem;
	object-fit: contain;
	position: relative;
	z-index: 2;
}

.visual-effects {
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
}

.effect-circle {
	position: absolute;
	border-radius: 50%;
	opacity: 0.1;
}

.effect-circle.blue {
	background: $primary;
	width: 8rem;
	height: 8rem;
	top: -2rem;
	right: -2rem;
}

.effect-circle.green {
	background: $success;
	width: 5rem;
	height: 5rem;
	bottom: 1rem;
	left: 1rem;
}

.card-content {
	padding: 1.75rem 1.5rem;
	flex: 1;
	display: flex;
	flex-direction: column;
}

.card-category {
	align-self: flex-start;
	background-color: rgba(0, 82, 204, 0.08);
	color: $primary;
	font-size: 0.75rem;
	font-weight: 600;
	padding: 4px 12px;
	border-radius: 100px;
	margin-bottom: 1rem;
	letter-spacing: 0.5px;
}

.card-title {
	font-size: 1.3rem;
	font-weight: 700;
	color: $heading;
	margin: 0 0 1rem;
	letter-spacing: -0.3px;
}

.card-text {
	font-size: 0.95rem;
	color: $body;
	line-height: 1.6;
	margin-bottom: 1.25rem;
}

.feature-list {
	list-style: none;
	padding: 0;
	margin: 0 0 1.25rem;
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
}

.feature-list li {
	font-size: 0.9rem;
	color: $body;
	display: flex;
	align-items: flex-start;
	gap: 0.5rem;
}

.feature-icon {
	width: 1rem;
	height: 1rem;
	fill: $success;
	flex-shrink: 0;
	margin-top: 0.125rem;
}

.action-button {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	background-color: $primary;
	color: #fff;
	border: none;
	padding: 0.75rem 1.25rem;
	border-radius: 8px;
	font-size: 0.9rem;
	font-weight: 600;
	margin-top: auto;
	cursor: pointer;
	transition: all 0.3s ease;
	gap: 0.5rem;

	&:hover {
		background-color: $primary-dark;
		transform: translateY(-2px);
		box-shadow: 0 6px 16px rgba(0, 82, 204, 0.3);
	}
}

.button-icon {
	width: 1rem;
	height: 1rem;
	fill: currentColor;
}

/* 应用卡片特殊样式 */
.app-card {
	display: flex;
	flex-direction: column;
	background: #fff;
	border-radius: 16px;
	overflow: hidden;
	border: 1px solid rgba(0, 82, 204, 0.08);
	box-shadow: 0 4px 18px rgba(0, 0, 0, 0.05);
	transition: all 0.35s cubic-bezier(0.22, 1, 0.36, 1);

	&:hover {
		transform: translateY(-6px);
		box-shadow: 0 16px 40px rgba(0, 82, 204, 0.15);
	}

	.card-visual {
		position: relative;
		background: linear-gradient(135deg, rgba(0, 82, 204, 0.08), #f5faff);
		padding: 20px;
		display: flex;
		justify-content: center;

		.app-mockup {
			background: #fff;
			border-radius: 24px;
			box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
			padding: 16px;
			width: 240px;

			.app-screen {
				.app-header {
					display: flex;
					align-items: center;
					margin-bottom: 12px;

					.app-icon {
						width: 36px;
						height: 36px;
						background: $primary;
						border-radius: 50%;
						display: flex;
						align-items: center;
						justify-content: center;
						margin-right: 10px;

						.feature-icon {
							width: 20px;
							height: 20px;
							fill: #fff;
						}
					}

					h4 {
						font-size: 16px;
						color: $heading;
					}
				}

				.app-preview-text {
					p {
						font-size: 13px;
						color: $body;
						margin-bottom: 8px;
					}

					.app-tags {
						list-style: none;
						padding: 0;
						display: flex;
						flex-wrap: wrap;
						gap: 6px;

						li {
							background: rgba(0, 82, 204, 0.08);
							color: $primary;
							padding: 4px 10px;
							border-radius: 12px;
							font-size: 12px;
						}
					}
				}
			}
		}

		.visual-effects {
			.effect-circle {
				position: absolute;
				border-radius: 50%;
				opacity: 0.4;
				animation: float 6s infinite ease-in-out alternate;

				&.blue {
					width: 100px;
					height: 100px;
					background: $primary;
					top: 10px;
					left: -30px;
				}

				&.green {
					width: 60px;
					height: 60px;
					background: $success;
					bottom: 0;
					right: 20px;
				}
			}
		}
	}

	.card-content {
		padding: 24px;

		.card-category {
			font-size: 13px;
			font-weight: bold;
			color: $primary;
			text-transform: uppercase;
			margin-bottom: 6px;
		}

		.card-title {
			font-size: 20px;
			font-weight: bold;
			color: $heading;
			margin-bottom: 10px;
		}

		.card-text {
			font-size: 14px;
			color: $body;
			margin-bottom: 20px;
		}

		.app-stats {
			display: flex;
			gap: 30px;

			.stat-item {
				.stat-value {
					font-size: 18px;
					font-weight: bold;
					color: $primary;
				}

				.stat-label {
					font-size: 12px;
					color: $silver;
				}
			}
		}
	}
}

@keyframes float {
	0% { transform: translateY(0px); }
	100% { transform: translateY(15px); }
}

/* 合作伙伴部分 */
.partners-section {
	margin-top: 3rem;
	text-align: center;
}

.partners-title {
	font-size: 1.125rem;
	color: $heading;
	font-weight: 700;
	margin-bottom: 1.5rem;
	position: relative;
	display: inline-block;
	letter-spacing: 0.5px;

	&::after {
		content: '';
		position: absolute;
		bottom: -0.5rem;
		left: 50%;
		transform: translateX(-50%);
		width: 50px;
		height: 3px;
		background: linear-gradient(to right, $primary, $primary-light);
		border-radius: 2px;
	}
}

.partners-grid {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
	gap: 1.5rem;
	margin-top: 1.75rem;
}

.partner-item {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 0.5rem;
	cursor: pointer;
}

.partner-logo {
	width: 5rem;
	height: 5rem;
	background: #fff;
	border: 1px solid rgba(0, 82, 204, 0.08);
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0.75rem;
	transition: all 0.3s cubic-bezier(0.22, 1, 0.36, 1);
	overflow: hidden;

	img {
		max-width: 100%;
		max-height: 100%;
		object-fit: contain;
		transition: all 0.3s ease;
		opacity: 0.85;
	}
}

.partner-item:hover .partner-logo {
	background: rgba(0, 82, 204, 0.08);
	transform: scale(1.1);
	box-shadow: 0 8px 20px rgba(0, 82, 204, 0.18);
	border-color: rgba(0, 82, 204, 0.3);

	img {
		opacity: 1;
	}
}

.partner-name {
	font-size: 0.78rem;
	color: $body;
	opacity: 0;
	transition: opacity 0.3s ease;
	font-weight: 500;
}

.partner-item:hover .partner-name {
	opacity: 1;
}

/* 响应式调整 */
@media (max-width: 1024px) {
	.cards-container {
		grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
	}
}

@media (max-width: 768px) {
	.cards-container {
		grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
		gap: 20px;
	}

	.partners-grid {
		grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
	}
}

@media (max-width: 480px) {
	.cards-container {
		grid-template-columns: 1fr;
		gap: 18px;
	}
}
</style>
